export default "__VITE_ASSET__e5b105b8__"